export default "__VITE_ASSET__DAGzwFoT__"